export default __webpack_public_path__ + "static/08.04-0338a8a75cee9ad69c68709bace1328b.png";